<template>
  <div class="layout-form">
    <joi-form :data="data" :schema="validationSchema" :error="formError" v-on:formdataready="save">
      <div class="row">
        <div class="small-4 columns small-centered">
          <span data-form-error-callout></span>
        </div>
      </div>

      <div class="row expanded">
        <div class="small-12 medium-6 columns">
          <label error-path="channels">
            Megfigyelt oldalak:
          </label>
          <channel-cards v-model="data.channels" :service="channelsService"></channel-cards>
        </div>
      </div>

      <div class="row expanded bottom">
        <div class="small-4 columns">
          <button type="submit" class="button primary trans-uppercase">Mentés</button>
          <button type="button" class="button secondary trans-uppercase" @click="back">Vissza</button>
        </div>
      </div>
    </joi-form>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
import * as mutationTypes from '../../store/mutation-types'
import JoiForm from '../../inputs/joi-form'
import ChannelCards from '../../inputs/channel-cards'
import {editInsightsSettings as validationSchema} from '../../../schemas'
import insightsService from '../../services/insights'
import channelsService from '../../services/channels'

export default {
  name: 'insights-settings',
  components: {
    JoiForm,
    ChannelCards
  },
  data () {
    return {
      data: {
        channels: []
      },
      validationSchema,
      formError: null,
      existingUser: false,
      channelsService: channelsService.list
    }
  },
  created: function () {
    this.load()
  },
  methods: {
    ...mapMutations([mutationTypes.BUSY_ON, mutationTypes.BUSY_OFF]),
    back () {
      this.$router.push({name: 'insights-query'})
    },
    load (id) {
      this.reset()
      this[mutationTypes.BUSY_ON]()
      insightsService.loadSettings().then((data) => {
        this[mutationTypes.BUSY_OFF]()
        if (data) {
          this.data = data
        }
      })
      .catch(() => {
        this[mutationTypes.BUSY_OFF]()
      })
    },
    reset () {
    },
    save (formData) {
      this[mutationTypes.BUSY_ON]()
      insightsService.saveSettings(formData).then((result) => {
        this[mutationTypes.BUSY_OFF]()
        this.back()
      }).catch((err) => {
        this[mutationTypes.BUSY_OFF]()
        this.formError = err
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  @import '../../../sass/foundation-import';
  @import '../../../sass/layouts/form';
</style>



// WEBPACK FOOTER //
// Settings.vue?1688f302